import { BizWalletDetail } from '@kakao/mfa-container'
import useWhiteBackground from './hooks/useWhiteBackground'
import { useParams } from 'react-router-dom'
import { CRUX_PHASE } from '../cruxConstants'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { refetchAdAccount } from '../../account/accountSlice'

const BizWalletDetailApp = () => {
  useWhiteBackground()
  const { accountId: adAccountId } = useParams()
  const dispatch = useDispatch()
  const accessToken = sessionStorage.getItem('accessToken')
  const refetch = useCallback(() => {
    dispatch(refetchAdAccount())
  }, [dispatch])
  return (
    <BizWalletDetail
      accessToken={accessToken}
      phase={CRUX_PHASE}
      assetId={adAccountId}
      assetType="AD_ACCOUNT_KEYWORD"
      basePath={`/${adAccountId}/settings/bizwallet`}
      onAssetConnect={refetch}
      onAssetDisConnect={refetch}
      onAssetConnectChange={refetch}
    />
  )
}
export default BizWalletDetailApp
